import * as React from "react";
import { Grid, Box, Divider, Radio, Typography, Tooltip } from "@mui/material";

// IMPORT CSS
import "../theme/style.scss";
import FormControlLabel from "@mui/material/FormControlLabel";

import VisibilityIcon from '@mui/icons-material/Visibility';

const PrescriptionTemplateSelection = (props: any) => {
  const {
    templates,
    handleTemplateClick,
    defaultTemplate,
    setDefaultTemplate,
  } = props;

  return (
    <>
      <Grid container spacing={2}>
        {templates?.map((item: any, index: number) => {
          const isSelected = defaultTemplate === item?.value;

          return (
            <Grid item xs={12} sm={4} key={index}>
              <Box
                key={index}
                className={
                  isSelected
                    ? "prescription-list-data selected"
                    : "prescription-list-data"
                }
              >
                <Box
                  className="prescription-template-card-header"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    padding: "9px 12px",
                    position: "relative",
                    backgroundColor: isSelected
                      ? "var(--opd-header-bg, #f0f6fb)"
                      : "var(--opd-subtle-bg, #fafafa)",
                  }}
                >
                  <Typography
                    variant="subtitle1"
                    sx={{
                      fontWeight: isSelected ? 700 : 600,
                      color: isSelected
                        ? "primary.main"
                        : "var(--opd-panel-fg, #333333)",
                      fontSize: "15px",
                      letterSpacing: "-0.2px",
                    }}
                  >
                    {item?.label}
                  </Typography>
                </Box>
                <Divider
                  sx={{
                    mx: -2.5,
                    mb: 1,
                    borderColor: "var(--opd-border-color, rgba(0,0,0,0.12))",
                  }}
                />
                <Box
                  className="prescription-thumbnail-wrapper"
                  onClick={(event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    handleTemplateClick(item, true);
                  }}
                >
                  <img src={item?.thumbnail} alt={item?.label} />
                </Box>
                <Divider
                  sx={{
                    mx: -2.5,
                    borderColor: "var(--opd-border-color, rgba(0,0,0,0.12))",
                  }}
                />
                <Box
                  className="prescription-template-card-footer"
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "4px 5px",
                    backgroundColor: isSelected
                      ? "var(--opd-header-bg, #f0f6fb)"
                      : "var(--opd-panel-bg, #ffffff)",
                  }}
                >
                  <Tooltip title="Preview" placement="top">
                    <VisibilityIcon
                      sx={{
                        fontSize: 20,
                        color: "primary.main",
                        cursor: "pointer",
                        marginLeft: "5px",
                      }}
                      onClick={(event) => {
                        event.stopPropagation();
                        handleTemplateClick(item, false);
                      }}
                    />
                  </Tooltip>
                  {isSelected ? (
                    <Typography
                      sx={{
                        color: "primary.main",
                        fontWeight: 600,
                        fontSize: "12px",
                        padding: "9px",
                      }}
                    >
                      Selected
                    </Typography>
                  ) : (
                    <FormControlLabel
                      label="Default"
                      sx={{
                        "& .MuiFormControlLabel-label": {
                          color: "var(--opd-muted-fg, #757575)",
                          fontWeight: 600,
                          fontSize: "12px",
                        },
                      }}
                      control={
                        <Radio
                          checked={isSelected}
                          value={item?.value}
                          onChange={(event) => {
                            event.stopPropagation();
                            setDefaultTemplate(item?.value);
                          }}
                          inputProps={{ "aria-label": "controlled" }}
                        />
                      }
                    />
                  )}
                </Box>
              </Box>
            </Grid>
          );
        })}
      </Grid>
    </>
  );
};

export default PrescriptionTemplateSelection;
